import APIService from '../api';
import { User } from './SigninTypes';
import {
  openCentralizedPopupWindow,
  onSigninPopupCloseRedirect
} from '@/utils/windowPopup';
import { insideProviderIframe } from '@/utils/providerIframe';

export const SOCIAL_LOGIN_REDIRECT_KEY = '@twism:social-redirect';

export default class SignIn extends APIService {
  login(password: string, mail: string, authType: string) {
    return this.post('/auth/signin', new User(mail, password, authType), { withCredentials: true });
  }

  loginWithProvider(
    provider: 'google' | 'apple',
    invitationData?: Record<string, string>
  ) {
    const url = `${this.host()}/auth/${provider}/authUrl/signin`;

    if (invitationData && invitationData.hasOwnProperty('redirect')) {
      localStorage.setItem(
        SOCIAL_LOGIN_REDIRECT_KEY,
        JSON.stringify(invitationData)
      );
    }

    if (insideProviderIframe()) {
      const newWindow = (openCentralizedPopupWindow(
        url,
        `${provider} Connect`,
        450,
        600
      ) as unknown) as Window;

      onSigninPopupCloseRedirect(newWindow);
    } else {
      location.href = url;
    }
  }
}
